export default __webpack_public_path__ + "static/media/15-100.b98c8a90.jpg";